<template>
  <div
    class="select is-multiple"
    v-bind="$attrs">
    <select
      multiple
      :size="size"
      v-model="value"
      :required="required">
      <option
        v-for="(option, i) in options"
        :value="option"
        :key="option + '-' + i">
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array
    },
    options: {
      type: Array
    },
    size: {
      default: 3
    },
    required: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
</style>
